export const APP_VERSION = '1.2.2';

export const VERSION_STORAGE_KEY = 'app_version';

export const API_BASE_URL = import.meta.env.VITE_API_URL;

export const VALIDATION_RULES = {
  MIN_PASSWORD_LENGTH: 8,
  MAX_PHONE_LENGTH: 15,
  MIN_BIRTH_YEAR: 1900,
  MAX_BIRTH_YEAR: 2010
};

export const SUPPORTED_COUNTRIES = {
    'Guatemala': 1,
    'El Salvador': 2,
    'Honduras': 3,
    'Nicaragua': 4,
    'Costa Rica': 5,
    'Panamá': 6,
    'República Dominicana': 7,
  };
